// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logowidth[data-v-6d827e5f]{max-width:145px;width:100%}.menu-transparent[data-v-6d827e5f]{opacity:.4}#main-nav[data-v-6d827e5f]{height:70px}@media only screen and (max-width:768px){#main-nav[data-v-6d827e5f]{height:80px}.logowidth[data-v-6d827e5f]{max-width:136px}}.main-menu[data-v-6d827e5f]{max-width:1440px;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
